import {bindable, customElement, inject} from "aurelia-framework";
import {parsePhoneNumberFromString, getCountries, getCountryCallingCode} from "libphonenumber-js";
import {UserClient} from "../api/user-client";

@inject(UserClient)
@customElement('sio-phone-input')
export class PhoneInput {

    @bindable({defaultBindingMode: 2}) value;
    @bindable country;

    input;

    selectConfig = {
        set: 'country-cc',
        translateChoiceLabel: false,
        required: true,
        multiple: false,
        default: 'DE'
    };

    customPrefixes = ['90'];

    constructor(user) {
        this.userCountry = user.getCountry();
    }

    bind() {
        if (!this.country) {
            this.country = this.userCountry;
        }

        this.valueChanged();
    }

    valueChanged() {
        const value = this.value || '';
        const parsed = parsePhoneNumberFromString(value, this.country);
        const customCode = this.customPrefixes.find(code => value.startsWith(`${code}-`));

        if (customCode) {
            this.country = customCode;
            this.phone = value.replace(`${customCode}-`, '');
        } else if (parsed) {

            let countries = {};

            for (let country of getCountries()) {
                let cc = getCountryCallingCode(country);

                if (!countries[cc]) {
                    countries[cc] = [];
                }

                countries[cc].push(country);
            }

            if (parsed.country) {
                this.country = parsed.country;
            } else if (countries?.[parsed.countryCallingCode]?.[0]) {
                this.country = countries?.[parsed.countryCallingCode]?.[0];
            } else {
                this.country = this.userCountry;
            }

            this.phone = parsed.nationalNumber;
        } else {
            this.resetPhone();
        }
    }

    resetPhone() {
        this.country = this.userCountry;
        this.phone = null;
    }

    _updateValue()
    {
        if (this.phone && this.country) {
            if (this.customPrefixes.includes(this.country)) {
                this.value = `${this.country}-${this.phone}`;
            } else {
                const parsed = parsePhoneNumberFromString(this.phone, this.country);
                this.value = parsed?.formatInternational()?.replace(/\s+/g, '-');
            }
        } else if (!this.phone && !this.country) {
            this.value = null;
        }
    }

    countryChanged() {
        this._updateValue();
    }

    phoneChanged() {
        this._updateValue();
    }
}
